import { render, staticRenderFns } from "./newPermission.vue?vue&type=template&id=a3378cce&scoped=true&"
import script from "./newPermission.vue?vue&type=script&lang=js&"
export * from "./newPermission.vue?vue&type=script&lang=js&"
import style0 from "./newPermission.vue?vue&type=style&index=0&id=a3378cce&lang=scss&scoped=true&"
import style1 from "./newPermission.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3378cce",
  null
  
)

export default component.exports